import {
  fetchAllCategories,
  fetchAllCategoriesPage,
} from "../../Redux/reducers/categorySlice";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";

// Custom hook for fetching and paginating categories
const useAddCategoryPageHook = () => {
  const dispatch = useDispatch();

  const [limit, setlimit] = useState(10)

  // Fetch all categories with a limit when the component mounts
  useEffect(() => {
    dispatch(fetchAllCategories({limit}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  // Select categories from the Redux store
  const categories = useSelector((state) =>
    state.category.categories.map((el) => ({
      ...el,
      id: el._id,
      image: el.image
        ? `${process.env.REACT_APP_API_URL}${el.image.replace(/^undefined\//, "")}`
        : "https://via.placeholder.com/150", // fallback
    }))
  );

   // Select totalPages from the Redux store
  const totalPages = useSelector((state) => state.category.totalPages);



  // Handle page change events
  const handlePageClick = (pageNumber) => {
    dispatch(fetchAllCategoriesPage({ page: pageNumber }));
  };

  // Get the loading state from the Redux store
  const loading = useSelector((state) => state.category.loading);

  // Return values for use in components
  return { categories, totalPages, loading, handlePageClick };
};

export default useAddCategoryPageHook;
